import React, {useContext, useEffect} from 'react'
import SideNav from './SideNav'
import { Outlet, useNavigate } from 'react-router-dom'
import { getItem } from '../login/storageService';
import {Navigate, useLocation} from "react-router-dom"
import { ContextApp } from '../ContextAPI';

function MainLayout(props) {

  const logged_in = getItem('loggedIn');
  const navigate = useNavigate();
  const {loggedIn, role} = useContext(ContextApp);
  // console.log("currwnt user from main layout", getItem('currentUser'))
  // const {role} = useContext(ContextApp);
  useEffect(() =>{
    if(role =='Admin'){
      console.log("not logged in", role)
    }
    else{
      navigate('/files')
      console.log("logged in", loggedIn)
    }
    if(!loggedIn){
      navigate('/login')
    }
    
  },[loggedIn, role])

  return (
    (loggedIn?
      <div className=' w-full h-full bg-gray-200 sm:flex '>
      <SideNav />
      <div className='w-full overflow-auto'>
      <Outlet />
      </div>
  </div>:
  <Navigate to="/login"  replace />
    )
   
  )
}

export default MainLayout